module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "rlist-card"
  }, [_c('div', {
    staticClass: "rlist-header"
  }, [_c('div', {
    staticClass: "rlist-header-main"
  }, [_c('span', {
    staticClass: "rlist-icon-pill"
  }, [(_vm.isInProgress) ? _c('svg', {
    attrs: {
      "width": "16",
      "height": "16",
      "viewBox": "0 0 24 24",
      "fill": "none",
      "stroke": "currentColor",
      "stroke-width": "1.8",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }
  }, [_c('circle', {
    attrs: {
      "cx": "12",
      "cy": "12",
      "r": "9"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M12 7v5l3 2"
    }
  })]) : _c('svg', {
    attrs: {
      "width": "16",
      "height": "16",
      "viewBox": "0 0 24 24",
      "fill": "none",
      "stroke": "currentColor",
      "stroke-width": "1.8",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }
  }, [_c('rect', {
    attrs: {
      "x": "3",
      "y": "4",
      "width": "18",
      "height": "18",
      "rx": "2"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M16 2v4M8 2v4M3 10h18"
    }
  })])]), _vm._v(" "), _c('div', [_c('h2', {
    staticClass: "rlist-title"
  }, [_vm._v(_vm._s(_vm.subtitle))]), _vm._v(" "), _c('p', {
    staticClass: "rlist-subtitle"
  }, [_vm._v(_vm._s(_vm.sectionDescription))])])]), _vm._v(" "), _c('span', {
    staticClass: "rlist-count-badge"
  }, [_vm._v(_vm._s(_vm.races.length) + " races")])]), _vm._v(" "), (_vm.loading) ? _c('div', {
    staticClass: "rlist-grid"
  }, _vm._l((3), function(n) {
    return _c('div', {
      key: 'race-list-skeleton-' + n,
      staticClass: "rlist-skeleton"
    }, [_c('div', {
      staticClass: "rlist-sk-media sk-shimmer"
    }), _vm._v(" "), _vm._m(0, true), _vm._v(" "), _c('div', {
      staticClass: "rlist-sk-title sk-shimmer"
    }), _vm._v(" "), _c('div', {
      staticClass: "rlist-sk-line sk-shimmer"
    }), _vm._v(" "), _vm._m(1, true)])
  }), 0) : (_vm.races.length) ? _c('div', {
    staticClass: "rlist-grid"
  }, _vm._l((_vm.races), function(race) {
    return _c('race-item', {
      key: race.id,
      attrs: {
        "type": _vm.type,
        "info": race
      },
      on: {
        "delete": function($event) {
          return _vm.$emit('delete', $event)
        }
      }
    })
  }), 1) : _c('div', {
    staticClass: "rlist-empty"
  }, [_c('svg', {
    staticClass: "rlist-empty-icon",
    attrs: {
      "width": "32",
      "height": "32",
      "viewBox": "0 0 24 24",
      "fill": "none",
      "stroke": "currentColor",
      "stroke-width": "1.5",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }
  }, [_c('path', {
    attrs: {
      "d": "M8 6h13M8 12h13M8 18h13"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M3 6h.01M3 12h.01M3 18h.01"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "rlist-empty-title"
  }, [_vm._v(_vm._s(_vm.messageEmptyList || 'No races found.'))])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "rlist-sk-top"
  }, [_c('div', {
    staticClass: "rlist-sk-pill sk-shimmer"
  }), _vm._v(" "), _c('div', {
    staticClass: "rlist-sk-date sk-shimmer"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "rlist-sk-actions"
  }, [_c('div', {
    staticClass: "rlist-sk-button sk-shimmer"
  }), _vm._v(" "), _c('div', {
    staticClass: "rlist-sk-icon sk-shimmer"
  })])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-2463cd70"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Race/RaceList.vue
// module id = 1684
// module chunks = 2